import { connect } from "react-redux";
import PropTypes from "prop-types";
import { quotationItemShape } from "app/utils/propTypes";
import { calculateFlexExtra, getPaymentDeltaBasePrice } from "app/pages/Booking/bookingSelectors";
import { useLocation } from "react-router-dom";
import QuotationItems from "app/pages/Booking/Quotation/PriceDetails/QuotationItems/QuotationItems";

const QuotationItemsContainer = ({ quotationItems = [], flexExtra = 0, deltaBasePrice = 0 }) => {
	const { pathname } = useLocation();
	const isPaymentPage = pathname.includes("/booking/payment");
	const isRestoreBookingSessionPage = pathname.includes("/booking/restoreSession");
	return (
		<QuotationItems
			quotationItems={quotationItems}
			flexExtra={flexExtra}
			deltaBasePrice={deltaBasePrice}
			isPaymentPage={isPaymentPage || isRestoreBookingSessionPage}
		/>
	);
};

QuotationItemsContainer.propTypes = {
	quotationItems: PropTypes.arrayOf(quotationItemShape),
	flexExtra: PropTypes.number,
	deltaBasePrice: PropTypes.number,
};

const mapStateToProps = state => {
	return {
		quotationItems: state.quotation.quotationItems,
		flexExtra: calculateFlexExtra(state),
		deltaBasePrice: getPaymentDeltaBasePrice(state),
	};
};

export default connect(mapStateToProps)(QuotationItemsContainer);
